import {
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

export function AuthInterceptor(
  request: HttpRequest<unknown>, 
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Login must not send a leftover bearer token. An expired token on this
  // request is what made a valid password fail in a normal browser and succeed
  // in a clean window or Swagger.
  const isCredentialRequest = /\/Auth\/(login|register)(\?|$)/i.test(request.url);
  const token = authService.getToken();

  if (token && !isCredentialRequest) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      const onSignIn = router.url.split('?')[0].startsWith('/sign-in');
      if (error.status === 401 && !isCredentialRequest && !onSignIn) {
        authService.logout();
        router.navigate(['/sign-in']);
      }

      return throwError(() => error);
    })
  );
}
